var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "group__radio" }, [
    _c(
      "div",
      { staticClass: "flex flex-wrap select-box" },
      [
        _vm._l(_vm.options, function (option) {
          return [
            _c(
              "label",
              {
                key: option.title,
                staticClass: "w-full text-base font-normal md:w-1/2 md:pr-3",
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.radioValue,
                      expression: "radioValue",
                    },
                  ],
                  attrs: { name: _vm.name, type: "radio" },
                  domProps: {
                    value: option.value,
                    checked: _vm._q(_vm.radioValue, option.value),
                  },
                  on: {
                    change: function ($event) {
                      _vm.radioValue = option.value
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "inline-block mr-2 radio" }),
                _vm._v(" " + _vm._s(option.title) + "\n      "),
              ]
            ),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }